var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.datas.tag)+" ")]),(_vm.datas.show)?_c('div',{staticClass:"echarts"},[_c('echarts',{attrs:{"option":_vm.datas.pieOption}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }